export function isEmpty(str: string | null | undefined): boolean {
  return str === null || str === undefined || str.trim() === ''
}

export function isNotEmpty(str: string | null | undefined): boolean {
  return !isEmpty(str)
}

export function isEmail(str: string): boolean {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return regex.test(str)
}

export function isPhoneCN(str: string): boolean {
  const regex = /^1[3-9]\d{9}$/
  return regex.test(str)
}

export function isPhone(str: string, country: string = 'CN'): boolean {
  const patterns: Record<string, RegExp> = {
    CN: /^1[3-9]\d{9}$/,
    US: /^\+?1?\d{10}$/,
    UK: /^\+?44?\d{10}$/,
    JP: /^\+?81?\d{10}$/,
    KR: /^\+?82?\d{9,10}$/,
  }
  const pattern = patterns[country]
  return pattern ? pattern.test(str) : isPhoneCN(str)
}

export function isIDCard(str: string): boolean {
  const regex = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/
  return regex.test(str)
}

export function isURL(str: string): boolean {
  const regex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/
  return regex.test(str)
}

export function isIP(str: string): boolean {
  const regex = /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/
  return regex.test(str)
}

export function isIPv6(str: string): boolean {
  const regex = /^([\da-fA-F]{1,4}:){7}[\da-fA-F]{1,4}$/
  return regex.test(str)
}

export function isNumber(str: string): boolean {
  const regex = /^-?\d+(\.\d+)?$/
  return regex.test(str)
}

export function isInteger(str: string): boolean {
  const regex = /^-?\d+$/
  return regex.test(str)
}

export function isFloat(str: string): boolean {
  const regex = /^-?\d+\.\d+$/
  return regex.test(str)
}

export function isChinese(str: string): boolean {
  const regex = /^[\u4e00-\u9fa5]+$/
  return regex.test(str)
}

export function isEnglish(str: string): boolean {
  const regex = /^[a-zA-Z]+$/
  return regex.test(str)
}

export function isAlphaNumeric(str: string): boolean {
  const regex = /^[a-zA-Z0-9]+$/
  return regex.test(str)
}

export function isPassword(str: string, minLength: number = 6, maxLength: number = 20): boolean {
  const regex = new RegExp(`^[a-zA-Z0-9!@#$%^&*()_+\\-=\\[\\]{};':"\\|,.<>/?]{${minLength},${maxLength}}$`)
  return regex.test(str)
}

export function isStrongPassword(str: string): boolean {
  const hasUpper = /[A-Z]/.test(str)
  const hasLower = /[a-z]/.test(str)
  const hasNumber = /\d/.test(str)
  const hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(str)
  const hasLength = str.length >= 8
  return hasUpper && hasLower && hasNumber && hasSpecial && hasLength
}

export function isPostalCode(str: string): boolean {
  const regex = /^\d{6}$/
  return regex.test(str)
}

export function isBankCard(str: string): boolean {
  const regex = /^\d{16,19}$/
  return regex.test(str)
}

export function isDate(str: string, separator: string = '-'): boolean {
  const regex = new RegExp(`^\\d{4}${separator}\\d{2}${separator}\\d{2}$`)
  return regex.test(str)
}

export function isTime(str: string, separator: string = ':'): boolean {
  const regex = new RegExp(`^\\d{2}${separator}\\d{2}${separator}\\d{2}$`)
  return regex.test(str)
}

export function isDateTime(str: string): boolean {
  const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/
  return regex.test(str)
}

export function isHexColor(str: string): boolean {
  const regex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/
  return regex.test(str)
}

export function isHTML(str: string): boolean {
  const regex = /<[a-z][\s\S]*>/i
  return regex.test(str)
}

export function startsWith(str: string, prefix: string): boolean {
  return str.startsWith(prefix)
}

export function endsWith(str: string, suffix: string): boolean {
  return str.endsWith(suffix)
}

export function contains(str: string, substring: string): boolean {
  return str.includes(substring)
}

export function isLength(str: string, min: number, max?: number): boolean {
  const len = str.length
  return max ? len >= min && len <= max : len >= min
}
